import { configureStore } from '@reduxjs/toolkit'
import listReducer from "./reducers/listSlice";
import randomReducer from './reducers/randomSlice';

export const store = configureStore({
  reducer: {
    list: listReducer,
    random: randomReducer,
  },
})